import type { LucideIcon } from 'lucide-react'
import { Building2, ChevronRight, GraduationCap } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type ChoiceProps = { icon: LucideIcon, title: string, description: string, onSelect: () => void }

/** Une carte de choix : toute la surface est cliquable, l'ambre dit l'action. */
function ChoiceCard({ icon: Icon, title, description, onSelect }: ChoiceProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className="group flex min-h-24 w-full items-center gap-4 rounded-2xl border-2 border-border bg-card p-5 text-left transition-colors hover:border-primary hover:bg-accent/40 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <span className="flex size-12 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
        <Icon className="size-6" aria-hidden />
      </span>
      <span className="flex flex-1 flex-col gap-1">
        <span className="font-heading text-lg font-semibold">{title}</span>
        <span className="text-sm text-muted-foreground">{description}</span>
      </span>
      <ChevronRight className="size-5 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" aria-hidden />
    </button>
  )
}

type Props = { onOrganization: () => void, onLearner: () => void }

/** Première étape de la demande d'essai : qui arrive ? (#155, #279) */
function SignupChoice({ onOrganization, onLearner }: Props) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-4">
      <p className="text-muted-foreground">{t('signup.choice.subtitle')}</p>
      <ChoiceCard icon={Building2} title={t('signup.choice.org.title')} description={t('signup.choice.org.description')} onSelect={onOrganization} />
      <ChoiceCard icon={GraduationCap} title={t('signup.choice.learner.title')} description={t('signup.choice.learner.description')} onSelect={onLearner} />
    </div>
  )
}

export default SignupChoice
